import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { Carousel, CarouselCard } from '../../components/Carousel';
import { Header } from '../../components/Header';
import { Subtitle } from '../../components/Subtitle';
import { ThingsToDoSection } from '../../components/ThingsToDoSection';
import { ONLINE_LOCATION_SLUG } from '../../constants';
import { useLocationContext } from '../../context';
import { CATEGORY_CONTENT_MAP } from './index';

export type Category = {
    display_name: string;
    url: string;
    tag: string;
    id: string;
};

export interface WaysToTourProps {
    categories?: Category[];
}

const getCategoryBrowseUrl = (categorySlug: string, locationSlug: string) => {
    return `/b/${locationSlug}/${categorySlug}/`;
};

export const WaysToTour: React.FunctionComponent<WaysToTourProps> = (props) => {
    const { shortPlaceName, location_slug } = useLocationContext();

    let title = gettext('Ways to Tour %(geo)s', {
        geo: shortPlaceName,
    });
    let subTitle = gettext(
        'Explore the best of %(geo)s through these popular event categories',
        { geo: shortPlaceName },
    );

    if (location_slug == ONLINE_LOCATION_SLUG) {
        title = gettext('Ways to explore Online');
        subTitle = gettext(
            'Explore the best Online activities through these popular event categories',
        );
    }

    return (
        <>
            {props.categories?.length ? (
                <ThingsToDoSection>
                    <Header title={title} />
                    <Subtitle text={subTitle} />
                    <Carousel cards={props.categories} noScrollMobile={true}>
                        {(category) => {
                            return (
                                <a
                                    data-testid="category-browse-link"
                                    key={category?.id}
                                    href={getCategoryBrowseUrl(
                                        CATEGORY_CONTENT_MAP[
                                            category?.tag || ''
                                        ].slug,
                                        location_slug || '',
                                    )}
                                >
                                    <CarouselCard
                                        title={
                                            CATEGORY_CONTENT_MAP[
                                                category?.tag || ''
                                            ].title
                                        }
                                        imageUrl={
                                            CATEGORY_CONTENT_MAP[
                                                category?.tag || ''
                                            ].imageUrl
                                        }
                                        imageLoading={'lazy'}
                                    />
                                </a>
                            );
                        }}
                    </Carousel>
                </ThingsToDoSection>
            ) : (
                <></>
            )}
        </>
    );
};
